import React, { useContext } from "react";
import { LayoutContext } from "@components/layout/Layout";
import theme from "@config/theme";

interface SidebarProps {
  children: React.ReactNode;
}

const Sidebar = ({ children }: SidebarProps) => {
  const { isAnnouncementBannerShowing } = useContext(LayoutContext);

  return (
    <>
      <div className="sidebar">{children}</div>
      <style jsx>
        {`
          .sidebar {
            position: sticky;
            padding-bottom: ${isAnnouncementBannerShowing
              ? `calc(4rem + ${theme.announcementBanner.height.largeScreen})`
              : `4rem`};
            top: ${isAnnouncementBannerShowing
              ? `calc(${theme.header.height} + ${theme.announcementBanner.height.largeScreen})`
              : `${theme.header.height}`};
            height: 100vh;
            overflow: auto;
            flex: 0 0 250px;
          }
          .sidebar :global(ul) {
            padding-left: 0;
            list-style: none;
          }
          .sidebar :global(ul ul) {
            padding-left: 1.5rem;
          }
          .sidebar :global(li) {
            margin-top: 1rem;
          }
        `}
      </style>
    </>
  );
};

export default Sidebar;
